import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideNgxMask } from 'ngx-mask';
import { errorInterceptor } from './shared/interceptors/error.interceptor';

import { routes } from './app.routes';
import { authInterceptor } from './shared/interceptors/auth.interceptor';

class PublicTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient) {}
  getTranslation(lang: string) {
    return this.http.get<Record<string, string>>(`/assets/i18n/${lang}.json`);
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(routes),
    provideHttpClient(),
    provideNgxMask(),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useClass: PublicTranslateLoader,
          deps: [HttpClient],
        },
        defaultLanguage: 'es',
      }),
    ),

    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
  ],
};
